<template>
	<div class="bc" @keyup.enter="goto">
		<!-- <div style="display: none;"> -->
		<div class="left">
			<img src="../assets/imgs/bg_login.jpg" alt="">
		</div>
		<div class="right">
			<section>
				<div class="top">
					<div>
						<img class="topImg" src="../assets/imgs/logo.png" alt="">
					</div>
					<div style="margin-left: 10px;margin-top: 0px;">
						<p class="title">江苏国际人才公寓管理平台</p>
						<p style="font-size: 14px;color: #666666;">JIANGSU INTERNATIONAL TALENT APARTIMENT MANGEMENT
							PLATFORM</p>
					</div>
				</div>

				<div class="topInput">
					<input class="input" type="text" v-model="formData.username" placeholder="账号" :maxlength="11">
				</div>
				<div class="topInput">
					<input class="input" type="password" v-model.trim="formData.password" placeholder="密 码"
						:maxlength="8">
				</div>
				<div class="bottomInput">
					<button class="loginBotton" @click="goto">登&nbsp;&nbsp;&nbsp;&nbsp;录</button>
				</div>
				<!-- <div class="bottomInput"> -->
				<div class="forget" @click="forget">忘记密码?</div>
				<!-- </div> -->
			</section>
		</div>
	</div>
</template>

<script>
	// import JSEncrypt from 'jsencrypt/bin/jsencrypt'
	export default {
		data() {
			return {
				formData: {
					// username: "18597841175",
					username: "admin",
					password: "123456"
				},
				time: "",
				num: 3,
			};
		},
		methods: {
			goto(e) {
				// if (this.formData.username.length < 5) {
				// 	this.$message.warning("请输入5到11位账号")
				// 	return
				// }
				if (this.formData.password.length < 4) {
					this.$message.warning("请输入4到8位密码")
					return
				}
				// if(e.keyCode==13){

				// }
				// const encryptor = new JSEncrypt()
				// encryptor.setPublicKey('MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' +
				//  '2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ==')
				// var encryptionPassword = encryptor.encrypt(this.formData.password);
				sessionStorage.removeItem("token")
				this.$http.post(`/api/auth/login`, this.formData).then(res => {
					if (res.data.code == 500) {
						this.$message.error(res.data.msg)
					}
					if (res.data.code == 200) {
						console.log(res.data);
						this.$message.success("欢迎登录人才大厦平台")
						sessionStorage.token = res.data.token
						console.log(res.data.token);
						console.log(localStorage.token);
						sessionStorage.createId = res.data.loginUser.user.id
						sessionStorage.roleId = res.data.loginUser.user.roleId
						sessionStorage.name = res.data.loginUser.user.name
						if (sessionStorage.roleId == 2) {
							this.$router.push("/index/console/statistics");
						} else {
							this.$router.push("/index/console/register");
						}
					}
				})
			},
			forget() {
				this.$router.push("/forget")
			}
		}
	}
</script>

<style scoped="scoped">
	.bc {
		width: 100%;
		height: 100%;
		display: flex;
	}

	.left,
	.right {
		width: 50%;
		height: 100%;
	}

	.left img {
		width: 100%;
		height: 100%;
	}

	.right {
		background-color: white;
	}

	section {
		margin-left: -10%;
	}


	.top {
		display: flex;
		justify-content: center;
		margin-top: 25%;
	}

	.topImg {
		width: 70px;
		height: 70px;
	}

	.title {
		color: #545B66;
		font-size: 36px;
		letter-spacing: 2px;
	}

	.loginBotton {
		margin: 0 auto;
		display: block;
		width: 70%;
		height: 50px;
		border: none;
		outline: none;
		text-align: center;
		color: white;
		cursor: pointer;
		background-color: #B4AC8A;
		font-size: large;
	}


	.input {
		width: 40%;
		margin: 20px auto;
		display: block;
		height: 42px;
		border: none;
		outline: none;
		border-bottom: 1px solid #DCDCDC;
		font-size: larger;
	}

	.bottomInput {
		width: 50%;
		margin: 40px auto 20px;
		position: relative;
		left: -20px;
	}

	.forget {
		width: 50%;
		margin: 0 auto;
		display: block;
		cursor: pointer;
		color: #666666;
		padding-left: 50px;
		font-size: 15px;
	}
</style>
